export default {
  Diaper: ['Wet', 'BM', 'Dry', 'BM & Wet', 'Dry & BM Tried'],
  Potty: ['Pee', 'BM', 'Tried']
};
